
// The way how we *already* collecting data. Any change here will spoil collected info.
// Please, only add new, not change. Unless management team is aware of consequences.
export const CUSTOM_DIMENSION_MAP = {
  dimension1: 'organization_type',
  dimension2: 'organization_id',
  dimension3: 'user_id',
  dimension4: 'agency_info',
  dimension5: 'brand_id',
  dimension6: 'campaign_info',
  dimension7: 'subcampaign_id',
  dimension8: 'influencer_id',
  dimension9: 'collection_info',
  /* start
   * These two are special and they are here to make this info accesable on GA4 side.
   * UA is supporting them out of the box.
   */
  dimension10: 'event_category',
  dimension11: 'event_label'
  /* end */
};
